import React from "react";
import ClickToFlyContent from "../components/click-to-fly/click-to-fly-content";

const ClickToFly = () => {
  return <ClickToFlyContent />;
};

export default ClickToFly;

